import { type Action, Actions, type State } from '../types';

function resetEnhancedState(state: State): State {
  return {
    ...state,
    currentEnhancedQuestion: undefined,
    enhancedQuestions: [],
    enhancedAnswers: new Map(),
    answeredEnhancedQuestionsIds: new Set()
  };
}

export function stateReducer(state: State, action: Action): State {
  switch (action.type) {
    case Actions.SET_MODAL_OPEN:
      return { ...state, isModalOpen: action.payload };
    case Actions.SET_PRODUCT_TYPE_ID:
      return { ...state, productTypeId: action.payload };
    case Actions.SET_PRODUCT_TYPE:
      return { ...state, productType: action.payload };
    case Actions.SET_SALES_PRICE:
      return { ...state, salesPrice: action.payload };
    case Actions.SET_LOADING:
      return { ...state, isLoading: action.payload };
    case Actions.SET_ENTRY:
      return { ...state, entry: action.payload, fetched: true };
    case Actions.SET_CURRENT_STEP:
      return { ...state, currentStep: action.payload };
    case Actions.SET_SELECTED_BRAND:
      return resetEnhancedState({ ...state, selectedBrand: action.payload });
    case Actions.SET_SELECTED_VARIANT:
      return resetEnhancedState({ ...state, selectedVariant: action.payload });
    case Actions.SET_VARIANT_CHOICES:
      return { ...state, variantChoices: action.payload };
    case Actions.SET_SELECTED_OPTION:
      return { ...state, selectedOption: action.payload };
    case Actions.SET_ANSWER:
      return typeof action.payload.questionId === 'undefined'
        ? state
        : {
            ...state,
            summary: null,
            answers: { ...state.answers, [action.payload.questionId]: action.payload.answer }
          };
    case Actions.SET_ANSWERS:
      return { ...state, answers: action.payload };
    case Actions.SET_SUMMARY:
      return { ...state, summary: action.payload };
    case Actions.SET_ENTRANCE_CHOICE:
      return { ...state, entranceChoice: action.payload };
    case Actions.SET_EXPLANATION_INFO:
      return { ...state, explanationInfo: action.payload };
    case Actions.SET_EXPLANATION_MODAL:
      return { ...state, isExplanationModalOpen: action.payload };
    case Actions.SET_ENHANCED_QUESTIONS:
      return {
        ...state,
        currentEnhancedQuestion: action.payload.length > 0 ? action.payload[0] : undefined,
        enhancedQuestions: action.payload
      };
    case Actions.SET_ENHANCED_ANSWER: {
      const { questionId, answer } = action.payload;
      const newAnswers = new Map(state.enhancedAnswers);
      newAnswers.set(questionId, answer);

      const newAnsweredIds = new Set(state.answeredEnhancedQuestionsIds);
      newAnsweredIds.add(questionId);

      return {
        ...state,
        enhancedAnswers: newAnswers,
        answeredEnhancedQuestionsIds: newAnsweredIds
      };
    }
    case Actions.SET_CURRENT_ENHANCED_QUESTION:
      return { ...state, currentEnhancedQuestion: action.payload };
    default:
      return state;
  }
}
